import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-549a99e0")

_pushScopeId("data-v-549a99e0")
const _hoisted_1 = { class: "list" }
const _hoisted_2 = { key: 3 }
const _hoisted_3 = { class: "list__records" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_OProgressSpinner = _resolveComponent("OProgressSpinner")
  const _component_ListError = _resolveComponent("ListError")
  const _component_ListEmpty = _resolveComponent("ListEmpty")
  const _component_InfiniteLoading = _resolveComponent("InfiniteLoading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_OProgressSpinner, {
          key: 0,
          class: "list__progress"
        }))
      : (_ctx.error)
        ? (_openBlock(), _createBlock(_component_ListError, {
            key: 1,
            title: _ctx.errorMsg,
            "retry-cb": _ctx.reloadCb,
            class: "list__error"
          }, null, 8, ["title", "retry-cb"]))
        : (!_ctx.records.length)
          ? (_openBlock(), _createBlock(_component_ListEmpty, {
              key: 2,
              "reload-cb": _ctx.reloadCb,
              class: "list__empty"
            }, null, 8, ["reload-cb"]))
          : (_openBlock(), _createBlock("div", _hoisted_2, [
              _createVNode("div", _hoisted_3, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.records, (record) => {
                  return (_openBlock(), _createBlock("div", {
                    key: record.id
                  }, [
                    _renderSlot(_ctx.$slots, "default", { record: record }, undefined, true)
                  ]))
                }), 128))
              ]),
              _createVNode(_component_InfiniteLoading, {
                class: "list__infinite",
                onInfinite: _ctx.infiniteCb
              }, null, 8, ["onInfinite"])
            ]))
  ]))
})